module.exports = __webpack_public_path__ + "assets/img/安全高效.e2072e7b.jpg";